import React, { useState } from "react";
import { Input, Button, Form, Label } from "reactstrap";
import ClearFilterImg from "../../assets/images/clear-filter.svg";

const OrderFilter = ({ onApply }) => {
	const [fromValue, setFromValue] = useState("");
	const [toValue, setToValue] = useState("");
	const [error, setError] = useState("");

	const isNumeric = (value: string) => /^\d+$/.test(value.trim());

	const handleApply = () => {
		if (!isNumeric(fromValue) || !isNumeric(toValue)) {
			setError("Both fields are required and must be valid numbers.");
			return;
		}
		if (+fromValue > +toValue) {
			setError("'From' value cannot be greater than 'To' value.");
			return;
		}
		setError("");
		onApply({ from: fromValue.trim(), to: toValue.trim() });
	};

	return (
		<Form className="d-flex align-items-baseline gap-2">
			<Label className="fw-bold mb-0">Order Filter:</Label>
			<div className="d-flex flex-column">
				<div className="d-flex align-items-center gap-2 flex-row">
					<span>From</span>
					<Input
						type="number"
						placeholder="Enter value"
						value={fromValue}
						onChange={(e) => {
							const val = e.target.value;
							if (/^\d*$/.test(val)) {
								if (val.length <= 9) {
									setFromValue(val);
								}
							}
						}}
						min="1"
						maxLength={9}
						className="no-spinner"
						style={{ width: "130px" }}
						onKeyDown={(e) => {
							if (["e", "E", "+", "-", "."].includes(e.key)) {
								e.preventDefault();
							}
						}}
					/>
					<span>To</span>
					<Input
						type="number"
						placeholder="Enter value"
						value={toValue}
						onChange={(e) => {
							const val = e.target.value;
							if (/^\d*$/.test(val)) {
								if (val.length <= 9) {
									setToValue(val);
								}
							}
						}}
						min="1"
						maxLength={9}
						className="no-spinner"
						style={{ width: "130px" }}
						onKeyDown={(e) => {
							if (["e", "E", "+", "-", "."].includes(e.key)) {
								e.preventDefault();
							}
						}}
					/>
				</div>
				{error && <span className="text-danger small">{error}</span>}
			</div>
			<Button
				color="primary"
				onClick={handleApply}
				disabled={!fromValue.trim() || !toValue.trim()}
			>
				Apply
			</Button>
			<img
				src={ClearFilterImg}
				alt="Clear Filter"
				style={{ cursor: "pointer" }}
				onClick={() => {
					setFromValue("");
					setToValue("");
					setError("");
					onApply({ from: null, to: null });
				}}
			/>
			{/* {error && <span className="text-danger ms-2">{error}</span>} */}
		</Form>
	);
};

export default OrderFilter;
